import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import webApi from '../webApi'
import { Vehicle } from '../webApi/DataModels'
import constants from '@/constants'

class VehicleState {
  public vehicles: Vehicle[] = []
  public vehicleOptions: any[] = []
}

const mutations = <MutationTree<VehicleState>>{
  setActiveVehicles (state: VehicleState, vehicles: any[]) {
    state.vehicles = vehicles
    state.vehicleOptions = vehicles.map((vehicle: any) => {
      return {
        value: vehicle.Vehicle_ID,
        label: vehicle.Vehicle_Type,
        selected: false
      }
    })
    window.sessionStorage.setItem('Vehicle_List', JSON.stringify(state.vehicles))
  },
  reset (state:VehicleState) {
    state.vehicles = []
    state.vehicleOptions = []
  }
}

const actions = <ActionTree<VehicleState, any>>{
  reset (store: ActionContext<VehicleState, any>):void {
    store.commit('reset')
  },
  loadVehicles (store: ActionContext<VehicleState, any>):Promise<any> {
    return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.PROVIDER, permissionValue: constants.PERMISSION_VALUES.LIST }, { root: true })
      .then((hasPermission): any => {
        if (!hasPermission) {
          return Promise.resolve('not needed')
        } else {
          if (window.sessionStorage.getItem('Vehicle_List') != null) {
          // the list has already been stored in session
            store.commit('setActiveVehicles', JSON.parse(window.sessionStorage.getItem('Vehicle_List')))
            return Promise.resolve('success')
          } else {
          // the list has not been stored in session yet, load from server
            return webApi.vehicle.get_Vehicles().then(
              (response) => {
                // Store the response
                store.commit('setActiveVehicles', response.data)
                return Promise.resolve('success')
              }).catch((response) => {
              window.bus.$emit('openErrorModal', 'error loading vehicles: ' + response.ExceptionMessage)
              return Promise.reject(response)
            })
          }
        }
      })
  }
}

const getters = <GetterTree<VehicleState, any>>{
  vehicles: (state) => {
    return state.vehicles
  },
  vehicleOptions: (state) => {
    return state.vehicleOptions
  }
}
export default ({
  namespaced: true,
  state: new VehicleState(),
  mutations,
  actions,
  getters
})
